module.exports = __webpack_public_path__ + "static/img/rank_124.b6f28dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_124.png
// module id = ZzZt
// module chunks = 0